
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgmIp1c6wHWUwk5uKbhBBl5MiVDjJdLCF3OEUmiUER0IMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/begagnat/index.vue?macro=true";
import { default as _91_46_46_46slug_930SqONZeRd49dlmyT_JWRqyVLQVT8GXZNgm_PZNoIwyYMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/deals/[...slug].vue?macro=true";
import { default as indexq8ylkSi5PVDDBp82Nku47fEU_uOVSGNOwx3LVCbjAf4Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/familjeabonnemang/index.vue?macro=true";
import { default as indexRSO_459Xout_y01Ng1Sf_459DGL2UodDeYoOdizLFgAcUL0Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/kontantkort/index.vue?macro=true";
import { default as indexvtcRtu4YnHK_452fb61lCxVkLS3R_7Eap5BrmvMTMJwjsMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobilabonnemang/index.vue?macro=true";
import { default as _91name_932R04Y7d9tcUfzi4TREXWuoV9k_Xt5lG_vlY5XtDUtEwMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/[name].vue?macro=true";
import { default as indexRY2RsqR_6rytNf0jBG4SDHVDzwORuBKvs6YgRruoB_MMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/index.vue?macro=true";
import { default as indexuk3pGgH5XgACxeULIFi9CEeHrSlyy5Rs8mX5ljfxCZwMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/index.vue?macro=true";
import { default as indexLqTwIcduYCVOavZsXmrglxfafCd7MaohykBu48e3WLYMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/betalstatus/index.vue?macro=true";
import { default as indexO_45AS2nHXpE2JD6H4iwHG9smqzrg_45HCmVCbfK_45fyQke4Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/byt-in/index.vue?macro=true";
import { default as expressCheckout1jKiEkE4pwvLk_0UeKFz0uwe3PbtRzrcmkVNnbiPiMkMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/expressCheckout.vue?macro=true";
import { default as _91orderGuid_93BOa8UntmcRHF2ZRz_6wiqdYRuJYqZ5z4e7uDDBE__UwMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/kvitto/[orderGuid].vue?macro=true";
import { default as _91orderId_zipCode_93mzUtWay5LZr4As4ma08vVufWWH97p2AcOoNDUBJSJk0Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/min-bestallning/[orderId_zipCode].vue?macro=true";
import { default as _91orderId_93u2ks7vhhIjJypgAmAEjQgfypya1WubJIRNPdLYdq5IgMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/[orderId].vue?macro=true";
import { default as indexNT91mkhCim21R_45Sx_Oem9UJVlHCW8lvQ3UqPVmY_45S2cMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/index.vue?macro=true";
import { default as _91orderGuid_934_45fMOLXoJZRymxp0wKgB1BSCYD4Bv5l2URDBEwqEaJoMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/standaloneteliapay/[orderGuid].vue?macro=true";
import { default as indexMR48UpumdYcff_KybjtCoUNLaPU_45NK9im44foRmAIm0Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/varukorg/index.vue?macro=true";
import { default as indexG9QH85vymbUaU36tJV4kDvgQHtO8Kxz5EkQ_45Oe3M87kMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/student/index.vue?macro=true";
import { default as _91name_932tVMG6BMsdsmPJz6gPSywMHqP0vV1VOXTSQ5o02V3XsMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/[name].vue?macro=true";
import { default as indexExGd5ljbtHXsFhxEKSPH7Ewemfr9_LKzDPosDzfo4MgMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/index.vue?macro=true";
import { default as index59Sbg_45hhYPBGr6cTNoEotqIHC_4516GsgZT4SklMUL4x0Meta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/index.vue?macro=true";
import { default as component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY } from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "begagnat",
    path: "/begagnat",
    meta: indexgmIp1c6wHWUwk5uKbhBBl5MiVDjJdLCF3OEUmiUER0IMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/begagnat/index.vue")
  },
  {
    name: "deals-slug",
    path: "/deals/:slug(.*)*",
    meta: _91_46_46_46slug_930SqONZeRd49dlmyT_JWRqyVLQVT8GXZNgm_PZNoIwyYMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/deals/[...slug].vue")
  },
  {
    name: "familjeabonnemang",
    path: "/familjeabonnemang",
    meta: indexq8ylkSi5PVDDBp82Nku47fEU_uOVSGNOwx3LVCbjAf4Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/familjeabonnemang/index.vue")
  },
  {
    name: "kontantkort",
    path: "/kontantkort",
    meta: indexRSO_459Xout_y01Ng1Sf_459DGL2UodDeYoOdizLFgAcUL0Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/kontantkort/index.vue")
  },
  {
    name: "mobilabonnemang",
    path: "/mobilabonnemang",
    meta: indexvtcRtu4YnHK_452fb61lCxVkLS3R_7Eap5BrmvMTMJwjsMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobilabonnemang/index.vue")
  },
  {
    name: "mobiltelefoner-manufacturer-name",
    path: "/mobiltelefoner/:manufacturer()/:name()",
    meta: _91name_932R04Y7d9tcUfzi4TREXWuoV9k_Xt5lG_vlY5XtDUtEwMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/[name].vue")
  },
  {
    name: "mobiltelefoner-manufacturer",
    path: "/mobiltelefoner/:manufacturer()",
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/index.vue")
  },
  {
    name: "mobiltelefoner",
    path: "/mobiltelefoner",
    meta: indexuk3pGgH5XgACxeULIFi9CEeHrSlyy5Rs8mX5ljfxCZwMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/index.vue")
  },
  {
    name: "shop-betalstatus",
    path: "/shop/betalstatus",
    meta: indexLqTwIcduYCVOavZsXmrglxfafCd7MaohykBu48e3WLYMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/betalstatus/index.vue")
  },
  {
    name: "shop-byt-in",
    path: "/shop/byt-in",
    meta: indexO_45AS2nHXpE2JD6H4iwHG9smqzrg_45HCmVCbfK_45fyQke4Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/byt-in/index.vue")
  },
  {
    name: "shop-expressCheckout",
    path: "/shop/expressCheckout",
    meta: expressCheckout1jKiEkE4pwvLk_0UeKFz0uwe3PbtRzrcmkVNnbiPiMkMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/expressCheckout.vue")
  },
  {
    name: "shop-kvitto-orderGuid",
    path: "/shop/kvitto/:orderGuid()",
    meta: _91orderGuid_93BOa8UntmcRHF2ZRz_6wiqdYRuJYqZ5z4e7uDDBE__UwMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/kvitto/[orderGuid].vue")
  },
  {
    name: "shop-min-bestallning-orderId_zipCode",
    path: "/shop/min-bestallning/:orderId_zipCode()",
    meta: _91orderId_zipCode_93mzUtWay5LZr4As4ma08vVufWWH97p2AcOoNDUBJSJk0Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/min-bestallning/[orderId_zipCode].vue")
  },
  {
    name: "shop-orderstatus-orderId",
    path: "/shop/orderstatus/:orderId()",
    meta: _91orderId_93u2ks7vhhIjJypgAmAEjQgfypya1WubJIRNPdLYdq5IgMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/[orderId].vue")
  },
  {
    name: "shop-orderstatus",
    path: "/shop/orderstatus",
    meta: indexNT91mkhCim21R_45Sx_Oem9UJVlHCW8lvQ3UqPVmY_45S2cMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/index.vue")
  },
  {
    name: "shop-standaloneteliapay-orderGuid",
    path: "/shop/standaloneteliapay/:orderGuid()",
    meta: _91orderGuid_934_45fMOLXoJZRymxp0wKgB1BSCYD4Bv5l2URDBEwqEaJoMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/standaloneteliapay/[orderGuid].vue")
  },
  {
    name: "shop-varukorg",
    path: "/shop/varukorg",
    meta: indexMR48UpumdYcff_KybjtCoUNLaPU_45NK9im44foRmAIm0Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/varukorg/index.vue")
  },
  {
    name: "student",
    path: "/student",
    meta: indexG9QH85vymbUaU36tJV4kDvgQHtO8Kxz5EkQ_45Oe3M87kMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/student/index.vue")
  },
  {
    name: "tillbehor-manufacturer-name",
    path: "/tillbehor/:manufacturer()/:name()",
    meta: _91name_932tVMG6BMsdsmPJz6gPSywMHqP0vV1VOXTSQ5o02V3XsMeta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/[name].vue")
  },
  {
    name: "tillbehor-manufacturer",
    path: "/tillbehor/:manufacturer()",
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/index.vue")
  },
  {
    name: "tillbehor",
    path: "/tillbehor",
    meta: index59Sbg_45hhYPBGr6cTNoEotqIHC_4516GsgZT4SklMUL4x0Meta || {},
    component: () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/index.vue")
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/abonnemang",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/shop",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/shop/kvitto",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/ladda",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  },
  {
    name: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWYMeta?.name,
    path: "/shop/min-bestallning",
    component: component_45stubWs_45RdZPHXHKxuL_BBB6Z9wOfgTmQ_CS75cFuzKI_CWY
  }
]